import * as Yup from 'yup'
import { TFunction } from '_metronic/i18n/Metronici18n'
import { MAC_REGEX } from '../../../core/formularioDispositivo'

export const max = (t: TFunction, limite: number) =>
  Yup.string().max(limite, t('pagina.dispositivos.validacao.max', { max: limite }))

/** Mesmos limites e mensagens dos DTOs de gestão do backend. */
export const dispositivoSchema = (t: TFunction) =>
  Yup.object().shape({
    empresa: Yup.object().nullable().required(t('pagina.dispositivos.validacao.empresa')),
    tipo: Yup.object().nullable().required(t('pagina.dispositivos.validacao.tipo')),
    serie: Yup.string()
      .trim()
      .required(t('pagina.dispositivos.validacao.serie'))
      .max(100, t('pagina.dispositivos.validacao.max', { max: 100 })),
    fabricante: max(t, 100),
    modelo: max(t, 100),
    patrimonio: max(t, 50),
    macAddress: Yup.string().test(
      'mac',
      t('pagina.dispositivos.validacao.mac'),
      (valor) => !valor?.trim() || MAC_REGEX.test(valor.trim())
    ),
    firmware: max(t, 50),
    registroAnvisa: max(t, 30),
    certificacaoAnatel: max(t, 30),
    certificacaoInmetro: max(t, 30),
    lote: max(t, 50),
    udiDi: max(t, 100),
    udiPi: max(t, 100),
    notaFiscal: max(t, 50),
    destinoBaixa: max(t, 150),
    garantiaAte: Yup.string().test(
      'garantiaDepoisDaAquisicao',
      t('pagina.dispositivos.validacao.garantia'),
      function (garantia) {
        const aquisicao: string | undefined = this.parent.dtAquisicao
        return !garantia || !aquisicao || garantia >= aquisicao
      }
    ),
    periodicidadeCalibracaoMeses: Yup.string().test(
      'periodicidade',
      t('pagina.dispositivos.validacao.periodicidade'),
      (valor) => {
        if (!valor?.trim()) return true
        const numero = Number(valor)
        return Number.isInteger(numero) && numero >= 1 && numero <= 120
      }
    ),
    situacao: Yup.object().nullable().required(t('pagina.dispositivos.validacao.situacao')),
    motivoBaixa: Yup.object()
      .nullable()
      .when('situacao', {
        is: (situacao?: { value?: string }) => situacao?.value === 'BAIXADO',
        then: (schema) => schema.required(t('pagina.dispositivos.validacao.motivo_baixa')),
      }),
  })

/** Campos DICOM/observação da alocação (mesmos limites do backend). */
export const camposDicomSchema = (t: TFunction) => ({
  modalidade: max(t, 16),
  descricao: max(t, 255),
  observacao: max(t, 500),
})
